<template>
  <div class="notification-all-body">
    <div
      class="d-flex align-items-center justify-content-end notification-modal-title-head"
    >
      <div class="title-head">
        <p class="notification-title-head">
          {{ $t("journeyBuilder.notificationSettings") }}
        </p>
      </div>
      <svg
        @click="$bvModal.hide('notification-modal')"
        class="CloseFeedbackSettings"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>
    <div class="notification-modal">
      <div v-for="setting in notificationSettings" :key="setting.name">
        <div
          class="d-flex align-items-center check-div"
          v-if="setting.type == 'boolean'"
        >
          <label class="label-email no-wrap">{{ setting.label }}</label>
          <b-form-checkbox
            switch
            class="switch-gray custom-switch-input"
            size="lg"
            v-model="$v.notificationSettingsModel.send_via_email.value.$model"
          ></b-form-checkbox>
        </div>

        <div
          class="email-con"
          v-if="
            setting.type == 'string' &&
            $v.notificationSettingsModel.send_via_email.value.$model
          "
        >
          <div class="d-flex align-items-center">
            <vp-input
              v-model="$v.notificationSettingsModel.send_to_email.value.$model"
              name="email"
              :label="$t('common.email')"
              width="416"
              :placeholder="$t('common.email')"
              :invalid="
                $v.notificationSettingsModel.send_to_email.value.$model.length >
                  0 && $v.notificationSettingsModel.send_to_email.value.$invalid
              "
              :disabled="
                !$v.notificationSettingsModel.$model.send_via_email.value
              "
            />
          </div>

          <div class="err-wrapper">
            <div
              v-if="
                $v.notificationSettingsModel.send_to_email.value.$model &&
                !$v.notificationSettingsModel.send_to_email.value.multiEmail
              "
            >
              <span class="text-danger">{{ $t('journeyBuilder.invalidEmailFormat')}}</span>
            </div>
            <p v-else class="email-notification">
              <b>{{ $t("common.notes.note") }}:</b>
              {{ $t("journeyBuilder.addMultipleEmails") }}
            </p>
          </div>
        </div>
      </div>

      <div
        v-if="
          $v.notificationSettingsModel.$model.send_via_email.value &&
          (earlySignOutReasons.length || lateSignInReasons.length) &&
          (lateSigninAlertSelected || earlySignoutAlertSelected)
        "
      >
        <div class="divider-line"></div>

        <p class="send-email-label">{{ $t('journeyBuilder.sendEmailIf')}}:</p>
        <div class="notifications-selections">
          <div class="signIn-reason" style="margin-bottom: 16px">
            <vp-multiselect
              :class="{
                arrSelected:
                  $v.notificationSettingsModel.late_signin_alert.metadata.$model
                    .length,
                'is-opened': isOpened,
              }"
              v-if="
                lateSignInReasons &&
                lateSignInReasons.length &&
                lateSigninAlertSelected
              "
              :options="lateSignInReasons"
              v-model="
                $v.notificationSettingsModel.late_signin_alert.metadata.$model
              "
              trackBy="id"
              label="label"
              :allowEmpty="true"
              width="416"
              :multiple="true"
              :title="$t('journeyBuilder.signInReason')"
              :showTitle="
                notificationSettingsModel.late_signin_alert.metadata.length > 0
              "
              dropDownStyle="relative"
              :showPlaceholderIcon="true"
              zIndex="3"
              :disabled="isAttendanceModeDisabled"
              @open="dropdownOpened"
              @close="dropdownClosed"
            />
          </div>
          <vp-multiselect
            :class="{
              arrSelected:
                $v.notificationSettingsModel.early_signout_alert.metadata.$model
                  .length,
              'is-opened2': isOpened2,
            }"
            v-if="
              earlySignOutReasons &&
              earlySignOutReasons.length &&
              earlySignoutAlertSelected
            "
            :options="earlySignOutReasons"
            v-model="
              $v.notificationSettingsModel.early_signout_alert.metadata.$model
            "
            width="416"
            trackBy="id"
            label="label"
            :multiple="true"
            title="Sign out Reason"
            :showTitle="
              notificationSettingsModel.early_signout_alert.metadata.length > 0
            "
            :showPlaceholderIcon="true"
            zIndex="2"
            dropDownStyle="relative"
            :allowEmpty="true"
            :disabled="isAttendanceModeDisabled"
            @open="dropdownOpened2"
            @close="dropdownClosed2"
          />
        </div>
        <p v-if="isAttendanceModeDisabled" class="multiselect-note">
          <b>{{ $t("common.notes.note") }}:</b>
          {{ $t("journeyBuilder.accessingReasonsNotAllowed") }}
        </p>
      </div>

      <div class="d-flex justify-content-end vp-mt-40 notification-btn">
        <button
          @click="submit"
          class="btn btn-primary notifications"
          :disabled="
            $v.notificationSettingsModel.$invalid ||
            !$v.notificationSettingsModel.$anyDirty
          "
        >
          {{ $t("common.save") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { requiredIf } from "vuelidate/lib/validators";
import { cloneDeep, compact } from "lodash";

export default {
  props: {
    settings: {
      default: () => [
        {
          name: "send_via_email",
          label: this.$t('journeyBuilder.sendVieEmail'),
          type: "boolean",
          value: false,
        },
        {
          name: "send_to_email",
          label: this.$t('journeyBuilder.sendToEmail'),
          type: "string",
          value: "",
        },
      ],
      type: Array,
    },
    dataModel: {
      default: () => {
        return {
          send_to_email: {
            id: null,
            value: "",
            metadata: null,
            type: "string",
          },
          send_via_email: {
            id: null,
            value: null,
            metadata: null,
            type: "boolean",
          },
          late_signin_alert: {
            id: null,
            value: null,
            metadata: [],
            type: "boolean",
            lateSignInReasons: [],
          },
          early_signout_alert: {
            id: null,
            value: null,
            metadata: [],
            type: "boolean",
            earlySignOutReasons: [],
          },
        };
      },
      type: Object,
    },
    currentAttendanceMode: {
      default: () => {},
      type: Object,
    },
    isAttendanceModeDisabled: {
      type: Boolean,
      default: false,
    },
    currentSelectedNotification: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    "$v.notificationSettingsModel.$model.send_via_email.value"() {
      if (!this.$v.notificationSettingsModel.$model.send_via_email.value) {
        this.$v.notificationSettingsModel.$model.send_to_email.value = "";
        // Reset late_signin_alert & early_signout_alert only if currently
        // selected attendance mode is permitted
        if (!this.isAttendanceModeDisabled) {
          this.$v.notificationSettingsModel.$model.late_signin_alert.metadata =
            [];
          this.$v.notificationSettingsModel.$model.early_signout_alert.metadata =
            [];
        }
      }
    },
  },
  data() {
    return {
      isOpened: false,
      isOpened2: false,
      notificationSettings: [],
      notificationSettingsModel: {
        send_via_email: {},
        send_to_email: {},
        late_signin_alert: [],
        early_signout_alert: [],
      },
      earlySignOutReasons: [],
      lateSignInReasons: [],
      lateSigninAlertSelected: null,
      earlySignoutAlertSelected: null,
    };
  },
  validations: {
    notificationSettingsModel: {
      send_via_email: {
        value: {},
      },
      send_to_email: {
        value: {
          required: requiredIf(function () {
            if (this.$v.notificationSettingsModel.send_via_email.value.$model)
              return true;
            return false;
          }),
          multiEmail: function (value) {
            if (!this.$v.notificationSettingsModel.send_via_email.value.$model)
              return true;

            let emails = compact(value.split(","));
            let isValid = true;
            emails?.forEach((email) => {
              if (isValid)
                isValid =
                  /^(([^<>()[\]\\.,;:\s@",]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/.test(
                    email
                  );
            });
            return isValid;
          },
          // multiEmail: function (value) {
          //   return !this.$v.notificationSettingsModel.send_via_email.value
          //     .$model
          //     ? true
          //     : /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/.test(
          //         value
          //       );
          // },
        },
      },
      late_signin_alert: {
        metadata: {
          required: requiredIf(function () {
            if (
              this.$v.notificationSettingsModel.send_via_email.value.$model &&
              this.lateSignInReasons?.length &&
              this.lateSigninAlertSelected
            )
              return true;
            return false;
          }),
        },
      },
      early_signout_alert: {
        metadata: {
          required: requiredIf(function () {
            if (
              this.$v.notificationSettingsModel.send_via_email.value.$model &&
              this.earlySignOutReasons?.length &&
              this.earlySignoutAlertSelected
            )
              return true;
            return false;
          }),
        },
      },
    },
  },
  beforeMount() {
    this.notificationSettings = cloneDeep(this.settings);
    this.notificationSettingsModel = cloneDeep(this.dataModel);

    this.lateSignInReasons =
      this.notificationSettingsModel.late_signin_alert.lateSignInReasons;
    this.earlySignOutReasons =
      this.notificationSettingsModel.early_signout_alert.earlySignOutReasons;

    this.lateSigninAlertSelected = this.currentSelectedNotification?.some(
      (opt) => opt.id == "105"
    );
    this.earlySignoutAlertSelected = this.currentSelectedNotification?.some(
      (opt) => opt.id == "106"
    );
    setTimeout(() => {
      this.$v.notificationSettingsModel.$reset();
    }, 0);
  },
  methods: {
    submit() {
      //Remove extra commas from email value
      this.notificationSettingsModel.send_to_email.value = compact(
        this.notificationSettingsModel.send_to_email.value.split(",")
      ).join(",");

      this.$emit("updateNotification", {
        settings: this.notificationSettingsModel,
      });
      this.$bvModal.hide("notification-modal");
    },
    dropdownOpened() {
      console.log("ooppp");
      this.isOpened = true;
    },
    dropdownClosed() {
      this.isOpened = false;
    },
    dropdownOpened2() {
      this.isOpened2 = true;
    },
    dropdownClosed2() {
      this.isOpened2 = false;
    },
  },
};
</script>
<style lang="scss">
:dir(rtl)
  div#notification-modal___BV_modal_content_
  .custom-control-input:checked
  ~ .custom-control-label:after {
  inset-inline-start: -5px !important;
}
:dir(ltr)
  div#notification-modal___BV_modal_content_
  .custom-control-input:checked
  ~ .custom-control-label:after {
  inset-inline-start: -34px !important;
}
div#notification-modal___BV_modal_content_ {
  width: 492px !important;
  box-shadow: 0px 1px 40px 3px #0000000d !important;
  border-radius: 26px !important;
  div#notification-modal___BV_modal_body_ {
    padding: 40px 38px !important;

    div[class*="vp-multiselect-"] .multiselect__placeholder {
      padding-bottom: 8px;
    }

    .is-opened2 .multiselect__tags {
      height: 55px !important;
    }
    .is-opened .multiselect__tags {
      height: 55px !important;
    }

    .arrSelected .multiselect__tags {
      padding-top: 30px !important;
      padding-bottom: 10px !important;
      // padding-inline-start: 20px !important;
    }

    .arrSelected .placeholder-icon {
      top: 6px !important;
    }

    .arrSelected input.multiselect__input {
      opacity: 0 !important;
      //position: absolute!important;
    }
    .arrSelected {
      .multiselect__content-wrapper {
        margin-top: -20px !important;
      }
    }
    input.multiselect__input {
      &::placeholder {
        color: #103f5e !important;
        font-weight: 400 !important;
      }
    }

    .multiselect__tag-icon:hover {
      background: #f46a6a !important;
    }
    .multiselect__tag {
      height: 39px !important;
      border-radius: 6px;
      font-weight: 700;
      padding: 11px 14px;
      font-size: 16px;
      line-height: 17px;
      letter-spacing: 0.25px;
    }
    .multiselect__tag span {
      margin-inline-end: 30px;
    }
    .multiselect__tag-icon {
      line-height: 39px !important;
      width: 32px;
    }
    .multiselect__tag-icon::after {
      content: "×";
      color: rgb(255, 255, 255);
      font-size: 24px;
      font-weight: 700;
    }
    .d-flex.align-items-center.check-div {
      width: 416px;
      justify-content: space-between;
      padding-inline-end: 10px;
      background: #f2f2f2;
      height: 55px;
      border-radius: 4px;
      margin-bottom: 16px !important;
      padding-inline-end: 20px;
      label.label-email.no-wrap {
        margin-bottom: 0px;
        margin-inline-start: 20px;
        font-size: 16px;
        line-height: 19px;
        font-weight: 700 !important;
        color: #787878;
      }
      .switch-gray {
        margin-top: -11px;

        .custom-control-input:checked ~ .custom-control-label::before {
          position: absolute;
          top: 6px !important;
          width: 43px;
          height: 21px;
          background: #d1d1d1;
          border: 1.5px solid #d1d1d1 !important;
          border-radius: 13.5px;
        }

        .custom-control-input:checked ~ .custom-control-label::after {
          width: 21px !important;
          height: 21px !important;
          top: 6px !important;
          background-color: #34c38f;
        }

        .custom-control-label::before {
          top: 6px !important;
          width: 43px !important;
          height: 21px !important;
          background: #d1d1d1;
          border: 1.5px solid #d1d1d1 !important;
          border-radius: 13.5px;
        }
        .custom-control-label::after {
          width: 21px !important;
          height: 21px !important;
          top: 6px !important;
          background: #939393;
          box-shadow: -1px 0px 3px rgba(0, 0, 0, 0.18) !important;
        }
      }
    }
    .email-con {
      .email-notification {
        font-size: 14px;
        line-height: 19px;
        color: #787878;
        margin-bottom: 0px !important;

        margin-inline-start: 20px;
      }
      .err-wrapper {
        margin-top: 8px !important;
        .text-danger {
          color: #f46a6a !important;
          font-weight: 600 !important;
          margin-inline-start: 20px !important;
          /* padding-top: 8px!important; */
          font-size: 14px !important;
          line-height: 19px;
        }
      }
    }
    .divider-line {
      width: 416px;
      height: 1px;
      margin: 32px auto 32px auto;
      background: #787878;
      opacity: 0.15;
    }
    .d-flex.justify-content-end.vp-mt-40.notification-btn {
      width: 416px;
      margin-inline-end: auto;
      margin-inline-start: auto;
      button.btn.btn-primary.notifications {
        width: 416px;
        border-radius: 22px;
        height: 44px;
        color: #ffffff;
        font-weight: 700;
        line-height: 17px;
        font-size: 16px;
        &:disabled {
          cursor: not-allowed;
          opacity: 0.4 !important;
        }
      }
    }
    p.multiselect-note {
      margin-top: 8px;
      margin-inline-start: 20px;
      margin-bottom: 0px !important;
      font-size: 14px;
      line-height: 19px;
      color: #787878;
      font-weight: 400;
    }
    p.send-email-label {
      color: #787878;
      font-size: 16px;
      line-height: 17px;
      font-weight: 600;
      margin-bottom: 32px;
    }
    .d-flex.align-items-center.justify-content-end.notification-modal-title-head {
      margin-inline-end: -5px;
      margin-bottom: 47px;
      p.notification-title-head {
        color: #000000;
        font-weight: 700;
        margin-bottom: 0px;
        font-size: 16px;
        line-height: 22px;
        margin-inline-end: 115px;
      }
    }
    .notification-modal {
      width: 416px;
      margin: auto;
    }
  }
}
</style>
